module.exports = __webpack_public_path__ + "static/media/empty-state-paths.7e286fbb.png";